import React from 'react';
import EstimationManagement from './abstract/EstimationManagement';
import Window from '../../../common/Window';
import Loading from '../../../common/component/Loading';

class EstimationHome extends EstimationManagement {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      isSearched: false,
      targetCategory: '',
      estimationList: [],
      isEditingCategory: false,
      isCategoryModalOpen: false,
      searchName: '',
      searchCategory: '',
      searchDateStart: '',
      searchDateEnd: '',
      currentPage: 1,
      itemsPerPage: 10,
      totalPages: 1,
    };
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.toggleCategoryModal = this.toggleCategoryModal.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentWillMount() {
    this.loadEstimationCategoryList();
    this.loadEstimationCount();
    this.loadEstimationList(this.state.currentPage);
  }

  handleSearchChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handlePageChange = (event) => {
    event.preventDefault();
    const { searchName, searchCategory, searchDateStart, searchDateEnd } = this.state;
    const filters = {
      searchName: searchName,
      searchCategory: searchCategory,
      searchDateStart: searchDateStart,
      searchDateEnd: searchDateEnd,
    };
    const page = parseInt(event.currentTarget.dataset.page, this.state.itemsPerPage);
    const onSuccess = (res) => {
      const estimationList = res.body.data.sort(this.sorter);
      this.setState({
        estimationList: estimationList,
        isSearched: true,
        currentPage: 1
      });
    };
    this.setState({ currentPage: page, isSearched: false });
    this.setState({ searchFilters: filters }, () => {
      this.loadEstimationCount(filters);
      this.loadEstimationList(page, filters, onSuccess);
    });
  }

  handleSearch = () => {
    const { searchName, searchCategory, searchDateStart, searchDateEnd } = this.state;
    const convertToNumericDate = (dateString, appendTime = 1) => {
      if (!dateString) return null;
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      let result = `${year}${month}${day}`;
      if (appendTime == 1) {
        result += '000000';
      } else {
        result += '235959';
      }
      return Number(result);
    };
    const numericSearchDateStart = convertToNumericDate(searchDateStart, 1);
    const numericSearchDateEnd = convertToNumericDate(searchDateEnd, 0);
    const filters = {
      searchName: searchName,
      searchCategory: searchCategory,
      searchDateStart: numericSearchDateStart,
      searchDateEnd: numericSearchDateEnd,
    };
    const onSuccess = (res) => {
      const estimationList = res.body.data.sort(this.sorter);
      this.setState({
        estimationList: estimationList,
        isSearched: true,
        currentPage: 1
      });
    };
    this.setState({ isSearched: false, currentPage: 1 });
    this.setState({ searchFilters: filters }, () => {
      this.loadEstimationCount(filters);
      this.loadEstimationList(this.state.currentPage, filters, onSuccess);
    });
  }

  handleReset = () => {
    this.setState({
      searchName: '',
      searchCategory: '',
      searchDateStart: '',
      searchDateEnd: '',
    });
  }

  toggleCategoryModal() {
    this.setState((prevState) => ({
      isCategoryModalOpen: !prevState.isCategoryModalOpen
    }));
  }

  onPageMenuClicked (name) {
    switch (name) {
      case 'demo':
        Window.confirm('デモデータを取り込みますか?', () => {
          this.makeDemoDeta()
        })
        break
      case 'add':
        this.props.history.push('/company_user/estimation/' + this.estimationType + '/add')
        break
      default:
        break
    }
  }
  selectEstimationCategory (category) {
    this.setState({
      targetCategory: category
    })
  }
  selected (id, e) {
    this.props.history.push('/company_user/estimation/' + this.estimationType + '/detail/' + id)
  }
  onCategoryEditButtonClicked (action, e) {
    e.preventDefault()
    switch (action) {
      case 'enter' :
        this.setState({
          targetCategory: '',
          isEditingCategory: true,
          saveMessage: '',
        })
        break
      case 'save' :
        this.saveEstimationCategory()
        this.setState({ saveMessage: '保存しました' })
        break
      case 'cancel' :
        this.setState({ isCategoryModalOpen: false, saveMessage: '' })
        break
      default:
        break
    }
  }
  changeCategoryName (offset, e) {
    e.preventDefault()
    const categoryList = this.state.categoryList.slice()
    if (categoryList[offset].id === 'default') {
      Window.alert(categoryList[offset].name + 'は変更することはできません。')
      return false
    }
    categoryList[offset].name = e.target.value
    this.setState({
      categoryList: categoryList
    })
  }
  saveEstimationCategory () {
    const categoryList = this.state.categoryList.slice()
    const errorIndex = []
    categoryList.forEach((category, index) => {
      if (category.name.trim() === '') {
        errorIndex.push(index + 1)
      }
    })
    if (errorIndex.length > 0) {
      Window.alert(errorIndex.join('、') + '番目のカテゴリが空です。\nカテゴリ名は必須です。')
      return false
    }
    this.saveCategory()
  }
  onInsert (offset) {
    offset = Number(offset)
    const categoryList = this.state.categoryList.slice()
    categoryList.splice(offset + 1, 0,
      {
        id: this.uuid(),
        name: ''
      }
    )
    this.setState({
      categoryList: categoryList
    })
  }
  onDelete (offset) {
    offset = Number(offset)
    const categoryId = this.state.categoryList[offset].id
    if (categoryId === 'default') {
      Window.alert('「' + this.state.categoryList[offset].name + '」は、削除することはできません。')
      return false
    }
    const estimationCountInThisCategory = this.state.estimationList.filter((e) => e.estimationCategoryId === categoryId).length
    let message = 'このカテゴリーを削除してもよろしいですか?'
    message += estimationCountInThisCategory === 0 ? '' : '\r\nこのカテゴリーに含まれる' + (this.isTemplate ? '雛形' : '見積書') + 'は未分類に移動されます。'
    if (this.state.categoryList.length > 1) {
      Window.confirm(message, () => {
        const categoryList = this.state.categoryList.slice()
        const estimationList = this.state.estimationList.slice()
        estimationList.forEach((estimation) => {
          if (estimation.estimationCategoryId === categoryId) {
            estimation.estimationCategoryId = 'default'
          }
        })
        categoryList.splice(offset, 1)
        this.setState({
          categoryList: categoryList,
          estimationList: estimationList
        })
        Window.closeDialog()
      })
    }
  }
  onMoveUp (offset) {
    offset = Number(offset)
    if (offset > 0) {
      const categoryList = this.state.categoryList.slice()
      categoryList.splice(offset - 1, 2, categoryList[offset], categoryList[offset - 1])
      this.setState({
        categoryList: categoryList
      })
    }
  }
  onMoveDown (offset) {
    offset = Number(offset)
    if (offset < this.state.categoryList.length - 1) {
      const categoryList = this.state.categoryList.slice()
      offset++
      categoryList.splice(offset - 1, 2, categoryList[offset], categoryList[offset - 1])
      this.setState({
        categoryList: categoryList
      })
    }
  }
  renderPageNavi () {
    const pageHeaderMain = this.isTemplate ? '雛型' : '見積書'
    const pageHeaderSub = this.isTemplate ? 'こちらから雛型の作成・編集・削除ができます。' : 'こちらから標準見積書の作成・編集・削除ができます。'
    const isDemoCategoryMade = (this.state.categoryList.filter((e) => e.id.startsWith('demo')).length > 0)
    const isDemoEstimationMade = (this.state.estimationList.filter((e) => e.estimationId.startsWith('demo')).length > 0)
    const makeDemoDetaButton = (this.state.isEditingCategory || this.isTemplate || isDemoCategoryMade || isDemoEstimationMade) ? '' : (
      <li className='kw-btn-area'>
        <a rel='tooltip' data-placement='left' title='サンプル取込み' className='text-center kw-btn-inverse' onClick={(e) => this.onPageMenuClicked('demo')}>
          <i className='icon-circle-arrow-down icon-large' /><br /><span>ﾃﾞﾓﾃﾞｰﾀ</span>
        </a>
      </li>
    )
    return (
      <section className='nav-page'>
        <div className='container'>
          <div className='row'>
            <div className='span8'>
              <header className='page-header'>
                <h3>{pageHeaderMain}<br />
                  <small>{pageHeaderSub}</small>
                </h3>
              </header>
            </div>
            <div className='span8'>
              <ul className='nav nav-pills'>
                {makeDemoDetaButton}
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='カテゴリ' className='text-center kw-btn-primary' onClick={this.toggleCategoryModal}>
                    <i className='icon-list icon-large' /><br /><span>ｶﾃｺﾞﾘ</span>
                  </a>
                </li>
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='新規の見積書を登録' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('add')}>
                    <i className='icon-plus icon-large' /><br /><span>新規</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    )
  }

  renderPagination() {
    const totalPages = Math.ceil(this.state.estimationCount / this.state.itemsPerPage);
    const currentPage = this.state.currentPage;
    const maxPagesToShow = 10; // 前後に表示するページ数
    let startPage, endPage;

    if (totalPages <= maxPagesToShow) {
      // ページ数が表示するページ数より少ない場合
      startPage = 1;
      endPage = totalPages;
    } else {
      // 表示するページ数の範囲を設定
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);
      if (currentPage <= halfMaxPagesToShow) {
        startPage = 1;
        endPage = maxPagesToShow;
      } else if (currentPage + halfMaxPagesToShow >= totalPages) {
        startPage = totalPages - maxPagesToShow + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - halfMaxPagesToShow;
        endPage = currentPage + halfMaxPagesToShow;
      }
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li key={i} className={currentPage === i ? 'active' : ''}>
          <a href="#" data-page={i} onClick={this.handlePageChange}>
            {i}
          </a>
        </li>
      );
    }

    return (
      <ul className="pagination">
        <li className={currentPage === 1 ? 'disabled' : ''}>
          <a href="#" data-page={1} onClick={this.handlePageChange}>
            &laquo;&laquo; 最初
          </a>
        </li>
        <li className={currentPage === 1 ? 'disabled' : ''}>
          <a href="#" data-page={currentPage - 1} onClick={this.handlePageChange}>
            &laquo; 前へ
          </a>
        </li>
        {pages}
        <li className={currentPage === totalPages || totalPages == 0 ? 'disabled' : ''}>
          <a href="#" data-page={currentPage + 1} onClick={this.handlePageChange}>
            次へ &raquo;
          </a>
        </li>
        <li className={currentPage === totalPages || totalPages == 0 ? 'disabled' : ''}>
          <a href="#" data-page={totalPages} onClick={this.handlePageChange}>
            最後 &raquo;&raquo;
          </a>
        </li>
      </ul>
    );
  }

  renderCategoryListToShow () {
    const categorySelector = this.state.categoryList.map((category) => {
      return (<li key={category.id} className={this.state.targetCategory === category.id ? 'active' : ''}>
        <a onClick={(e) => this.selectEstimationCategory(category.id)}><i className='icon-chevron-right pull-right' />{category.name}</a>
      </li>)
    })
    return (
      <ul className='nav nav-list' id='person-list'>
        <li className='nav-header'>カテゴリ<span className='pull-right'>
          <a onClick={(e) => this.onCategoryEditButtonClicked('enter', e)}><i className='icon-edit' />「ｶﾃｺﾞﾘｰ」を編集</a>
        </span></li>
        <li key='all' className={this.state.targetCategory === '' ? 'active' : ''} onClick={(e) => this.selectEstimationCategory('')}>
          <a id='view-all'>
            <i className='icon-chevron-right pull-right' />
            <b className='kw-category-title'>全てのカテゴリを表示</b>
          </a>
        </li>
        {categorySelector}
      </ul>
    )
  }
  renderEstimationListBox(state) {
    const { searchName, searchCategory, searchDateStart, searchDateEnd } = state;
    const targetCategoryList = state.categoryList;
    const estimationList = state.estimationList;

    let estimationListToShow = estimationList.map((estimation) => {
      const dateTime = estimation.lastUpdateDateTime.toString();
      const category = targetCategoryList.find(
        (category) => category.id === estimation.estimationCategoryId
      );
      const categoryName = category ? category.name : '';

      return (
        <tr key={estimation.estimationId} onClick={(e) => this.selected(estimation.estimationId, e)}>
          <td>{estimation.estimationType === 'real' ? estimation.estimationTitle : estimation.estiamtionprimeContractor}</td>
          <td>{categoryName}</td>
          <td>{`${dateTime.substr(0, 4)}/${this.zeroPack(dateTime.substr(4, 2))}/${this.zeroPack(dateTime.substr(6, 2))} ${dateTime.substr(8, 2)}:${dateTime.substr(10, 2)}`}</td>
          <td>{estimation.lastUpdateUserName}</td>
        </tr>
      );
    });

    if (this.state.isSearched === false) {
      estimationListToShow = (
        <tr key="zero">
          <td colSpan="4" className="text-center">
            データ取得中...
          </td>
        </tr>
      );
    }

    if (estimationListToShow.length === 0) {
      estimationListToShow = (
        <tr key="zero">
          <td colSpan="4" className="text-center">
            現在登録されている見積書はありません
          </td>
        </tr>
      );
    }

    return (
      <div className="box">
        <div className="box-header">
          <div className="btn-group-box form-search">
            <input
              class="search-name form-area"
              type="text"
              name="searchName"
              value={searchName}
              placeholder="名称で検索"
              onChange={this.handleSearchChange}
            />
            <select
              class="search-category form-area"
              name="searchCategory"
              value={searchCategory || ""}
              onChange={this.handleSearchChange}
            >
              <option value="">カテゴリを選択</option>
              {targetCategoryList.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
            <input
              class="search-date"
              type="text"
              name="searchDateStart"
              value={searchDateStart}
              placeholder="YYYY/MM/DDで検索"
              onChange={this.handleSearchChange}
            />～
            <input
              class="search-date form-area"
              type="text"
              name="searchDateEnd"
              value={searchDateEnd}
              placeholder="YYYY/MM/DDで検索"
              onChange={this.handleSearchChange}
            />
            <button class="form-area text-center search-button kw-btn-primary" onClick={this.handleSearch}>
              <i className='icon-search icon-large' /><span> 検索 </span>
            </button>
            <button class="form-area text-center search-button kw-btn-primary" onClick={this.handleReset}>
              <i className='icon-arrow-left icon-large' /><span> リセット</span>
            </button>
          </div>
        </div>
        <div className="box-footer">{this.renderPagination()}</div>
        <div className="box-content box-table">
          <table className="table table-hover tablesorter kw-category-list-tbl">
            <thead>
              <tr>
                <th width="50%">名称</th>
                <th width="20%">カテゴリ</th>
                <th width="15%">最終更新日時</th>
                <th width="15%">最終更新者</th>
              </tr>
            </thead>
            <tbody>
              {estimationListToShow}
            </tbody>
          </table>
        </div>
        <div className="box-footer">{this.renderPagination()}</div>
      </div>
    );
  }
  renderCategoryListToEdit () {
    const categoryEditor = this.state.categoryList.map((category, index) => {
      return (
        <tr key={'edit' + category.id}>
          <td>
            <input type='text' value={category.name} onChange={(e) => this.changeCategoryName(index, e)} style={category.id === 'default' ? {backgroundColor: '#cccccc'} : {}} />
          </td>
          <td className='kw-gyou-sousa-icons'>
            <span className='text-success'><i className='icon-plus-sign kw-pointer' onClick={(e) => this.onInsert(index)} /></span>
            <span className='text-info'><i className='icon-circle-arrow-up' style={index === 0 ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={(e) => this.onMoveUp(index)} /></span>
            <span className='text-error'><i className='icon-minus-sign' onClick={(e) => this.onDelete(index)}
              style={(this.state.categoryList.length <= 1 || category.id === 'default') ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(185, 74, 72)', cursor: 'pointer'}} /></span>
            <span className='text-info'><i className='icon-circle-arrow-down' style={index === this.state.categoryList.length - 1 ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={(e) => this.onMoveDown(index)} /></span>
          </td>
        </tr>
      )
    })
    return (
      <ul className='nav nav-list' id='person-list'>
        <li className='nav-header'>カテゴリ</li>
        <li className='text-center'>
          <button className='btn btn-small btn-primary' onClick={(e) => this.onCategoryEditButtonClicked('save', e)}><i className='icon-edit' />ｶﾃｺﾞﾘｰの変更を保存</button>　
          <button className='btn btn-small btn-default' onClick={(e) => this.onCategoryEditButtonClicked('cancel', e)}><i className='icon-edit' />終了</button>
          <hr />
          {this.state.saveMessage && <div className="alert alert-success">{this.state.saveMessage}</div>}
        </li>
        <li>
          <table className='kw-category-input-tbl'>
            <tbody>
              {categoryEditor}
            </tbody>
          </table>
        </li>
      </ul>
    )
  }
  render () {
    if (!this.state.isLoaded || !this.state.isEstimationCategoryLoaded) {
      return <Loading />
    }
    const pageNavi = this.renderPageNavi()
    const estimationListBox = this.renderEstimationListBox(this.state)
    const categoryBox = this.renderCategoryListToEdit()
    return (
      <div>
        {pageNavi}
        <section className='page container'>
          <div className='row'>
            <div className='kw-category-content-area'>
              {estimationListBox}
            </div>
          </div>
        </section>
        {this.state.isCategoryModalOpen && (
          <div className="modal">
            <div className="modal-content">
              <span className="close" onClick={this.toggleCategoryModal}>&times;</span>
              {categoryBox}
            </div>
          </div>
        )}
      </div>
    )
  }

}

export default EstimationHome



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationHome.js